import React,{useState} from "react";
import { Box, Button } from "@mui/material";
import { setupManagementUrl } from "../../../../config";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
import CollateralConditionForm from "./forms";
import Joyride from "react-joyride"; // Import Joyride

const base_url = setupManagementUrl.uri;

// Define Joyride tour steps
const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Collateral Condition Management page, where you can manage Collateral Conditions.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find a specific Collateral Condition by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new Collateral Condition.",
    placement: "right",
  },
  {
    target: ".dynamic-table-actions",
    content: "Select actions like Edit or Deactivate for each Collateral Condition from this dropdown.",
    placement: "left",
  },
];
const CollateralConditionPage = () => {
   const [runTour, setRunTour] = useState(false); //  State to control Joyride
  
  const actions = {
    entity: localStorage.getItem("SelectedTabLabel"),
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    dataObject: {
      ignoreFields: ["UpdateDate", "CreateDate","Createdby","Updatedby","Updatedate"],
      objectName: "collateralConditions",
      parameters: "",
    },
    required: "rightIds",
    isSubRight: true,
    showStatus:true,
    showMore:{
      search:false,
      min: 0,
      max:0
    }
  };

  return (
    <Box m="20px">
        {/* Joyride Component */}
                  <Joyride
                    steps={rightsTourSteps}
                    run={runTour}
                    continuous
                    showSkipButton
                    showProgress
                    styles={{
                      options: {
                        primaryColor: "#1976d2",
                        zIndex: 10000,
                      },
                    }}
                  />
                  {/* Top Bar */}
                      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                        <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
                          Start Page Tour
                        </Button>
                      </Box>  
      <DynamicTableForJson
        title="Collateral Condition Management"
        subtitle="Manage Collateral Condition"
        FormComponent={CollateralConditionForm}
        base_url={base_url}
        actions={actions}
        tourSteps={rightsTourSteps} // Still passed in case DynamicTable needs it

      />
    </Box>
  );
};

export default CollateralConditionPage;